import DrawerWrapper from '@components/drawer/drawer-wrapper';
import ContainerTitle from '@components/ui/container-title';
import { Button, Stack } from '@mui/material';
import FOCityLedgerAccountsTable from './fo-cityledger-accounts-table';

const FOCityLedgerDrawer = ({
  onCloseDrawer = () => {},
  isOpen,
}: {
  onCloseDrawer: () => void;
  isOpen: boolean;
}) => {
  return (
    <DrawerWrapper
      open={isOpen}
      onClose={onCloseDrawer}
      stickyCloseIcon
      sx={{
        '& .MuiDrawer-paper': {
          width: { xs: '100%', lg: 'auto' },
        },
      }}
    >
      <Stack
        flex={1}
        sx={{
          width: { xs: '100%', lg: '1100px' },
          overflow: { sx: 'auto', md: 'auto' },
        }}
      >
        {/* HEADER */}
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          gap={{ xs: 1, md: 2 }}
          sx={{
            p: '20px',
            borderBottom: '1px solid #EEE',
            position: 'sticky',
            top: 0,
            bgcolor: 'white',
            zIndex: 21,
          }}
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            sx={{
              pl: '5px',
            }}
          >
            <ContainerTitle
              title='City Ledger List'
              func={() => {}}
              titleStyle={{ fontSize: '20px!important' }}
            />
          </Stack>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            gap={{ xs: 10, md: 15 }}
            sx={{
              marginLeft: 'auto',
              alignItems: 'center',
              justifyContent: 'flex-end',
              pr: '200px',
              pt: '7px',
            }}
          ></Stack>
        </Stack>

        {/* MAIN BODY */}

        <FOCityLedgerAccountsTable />
      </Stack>

      {/* FOOTER */}
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='flex-end'
        paddingRight={5}
        paddingBottom={2}
      >
        <Button variant='outlined' onClick={onCloseDrawer}>
          Close
        </Button>
      </Stack>
    </DrawerWrapper>
  );
};

export default FOCityLedgerDrawer;
